import { type OrderDraftApiModel } from '../api-models/OrderDraftApiModel'
import { type GetOrderDraftComputedValuesResponse } from '../types/GetOrderDraftComputedValuesResponse'

export const mapOrderDraftComputedValues = (
  order: OrderDraftApiModel
): GetOrderDraftComputedValuesResponse => ({
  dateModified: order.date_modified ?? null,
  totalCost: order.total_price ? Number(order.total_price) : null,
  totalCostInBaseCurrency: order.total_cost_in_base_currency,
})
